module.exports = {
  FontFamilies: {
    Primary:
      "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    Monospace:
      "'ABC Monument Grotesk Mono', 'Lucida Console', ui-monospace, SFMono-Regular, Monaco, Consolas, 'Andale Mono', 'Ubunto Mono', monospace",
  },
};
